import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import UserInfo from '../views/UserInfo.vue'
import Download from '../views/Download.vue'

const routes = [
  {
    path: '/:inviteCode?',
    name: 'Login',
    component: Login
  },
  {
    path: '/user-info',
    name: 'UserInfo',
    component: UserInfo
  },
  {
    path: '/download',
    name: 'Download',
    component: Download
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
